import React from 'react';
import { Link } from 'react-router-dom';
import BrandMark from '../../../components/BrandMark';

interface MarketingLogoProps {
  onDark?: boolean; // version claire, posée sur un fond sombre
  className?: string;
}

// Logo « RSVP Please » (symbole + nom) : lien vers l'accueil du site vitrine.
const MarketingLogo: React.FC<MarketingLogoProps> = ({ onDark = false, className = '' }) => (
  <Link to="/" className={['mk-logo', onDark ? 'on-dark' : '', className].filter(Boolean).join(' ')}>
    <BrandMark className="mk-logo-mark" />
    <span>
      RSVP <em>Please</em>
    </span>
  </Link>
);

export default MarketingLogo;
